import React, { useState, useEffect } from 'react';
import { Menu, X, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-12 py-3 md:py-4">
        <div className="flex items-center justify-between h-12 md:h-16">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => scrollToSection('home')}>
            <div className="flex items-center gap-2 md:gap-3">
              <div className={`relative ${isScrolled ? 'text-amber-600' : 'text-amber-400'}`}>
                <Sparkles size={24} className="hidden sm:block animate-pulse" />
                <Sparkles size={20} className="sm:hidden animate-pulse" />
              </div>
              <div>
                <h1 className={`text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold tracking-tight transition-colors duration-300 ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`} style={{ fontFamily: "'Playfair Display', serif" }}>
                  Made in Heaven
                </h1>
                <p className={`text-[10px] sm:text-xs tracking-widest uppercase transition-colors duration-300 ${
                  isScrolled ? 'text-amber-600' : 'text-amber-300'
                }`}>
                  Events & Celebrations
                </p>
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`transition-colors duration-300 hover:text-amber-600 ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`transition-colors duration-300 hover:text-amber-600 ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`transition-colors duration-300 hover:text-amber-600 ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className={`transition-colors duration-300 hover:text-amber-600 ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`transition-colors duration-300 hover:text-amber-600 ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Testimonials
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-amber-600 hover:bg-amber-700 text-white transition-colors duration-300"
            >
              Contact Us
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`transition-colors duration-300 ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg rounded-lg mt-2 py-4 px-4 space-y-4">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left py-2 text-gray-800 hover:text-amber-600 transition-colors"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left py-2 text-gray-800 hover:text-amber-600 transition-colors"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left py-2 text-gray-800 hover:text-amber-600 transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="block w-full text-left py-2 text-gray-800 hover:text-amber-600 transition-colors"
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left py-2 text-gray-800 hover:text-amber-600 transition-colors"
            >
              Testimonials
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-amber-600 hover:bg-amber-700 text-white"
            >
              Contact Us
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
